<template>
	<v-list-item @click="$emit('click')">
		<v-list-item-avatar>
			<v-icon>mdi-account</v-icon>
		</v-list-item-avatar>
		<v-list-item-content>
			<v-list-item-title v-text='Attributes.name' />
			<v-list-item-subtitle v-text="Username" />
		</v-list-item-content>
	</v-list-item>
</template>

<script>
import UserService from '@/services/UserService'

export default {
	name: 'UserItem',
	props: {
		Username: String,
		UserStatus: String,
		Attributes: Object,
	}
}
</script>

<style lang="scss" scoped>
</style>